export default "__VITE_ASSET__RanClfs2__$_?nuxt_component=async&nuxt_component_name=SvgoFuturesDelivering&nuxt_component_export=default__"